import { render, staticRenderFns } from "./ResetPassword.html?vue&type=template&id=27d82b61&scoped=true&"
import script from "./ResetPassword.js?vue&type=script&lang=js&"
export * from "./ResetPassword.js?vue&type=script&lang=js&"
import style0 from "./ResetPassword.scss?vue&type=style&index=0&id=27d82b61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d82b61",
  null
  
)

export default component.exports